import { createContext, useContext, useState, useCallback } from "react";

const EnrollContext = createContext(null);

export const EnrollProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [plan, setPlan] = useState("Professional");

  const openEnroll = useCallback((selectedPlan = "Professional") => {
    setPlan(selectedPlan);
    setOpen(true);
  }, []);

  return (
    <EnrollContext.Provider value={{ open, setOpen, plan, setPlan, openEnroll }}>
      {children}
    </EnrollContext.Provider>
  );
};

export const useEnroll = () => {
  const ctx = useContext(EnrollContext);
  if (!ctx) throw new Error("useEnroll must be used within EnrollProvider");
  return ctx;
};
